import { render, staticRenderFns } from "./EventAdminAdd.vue?vue&type=template&id=1dbe64d6&scoped=true&"
import script from "./EventAdminAdd.vue?vue&type=script&lang=js&"
export * from "./EventAdminAdd.vue?vue&type=script&lang=js&"
import style0 from "./EventAdminAdd.vue?vue&type=style&index=0&id=1dbe64d6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1dbe64d6",
  null
  
)

export default component.exports